var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard-analytics"}},[_c('b-row',{staticClass:"match-height"},[_c('b-col',{attrs:{"lg":"6","md":"12"}},[_c('analytics-congratulation',{attrs:{"data":_vm.userData}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }